import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DockWrapper, DockContent, DockItem, DockIcon, DockLabel, DoneButton } from './dock.styled';
import { useDock } from './dock.hooks';
import { useAuth } from '../../../contexts/auth/auth-context';

interface DockProps {
  variant?: 'default' | 'question' | 'done';
  onTypeClick?: () => void;
  onRecordClick?: () => void;
  onDoneClick?: () => void;
  disabled?: boolean;
}

export const Dock: React.FC<DockProps> = ({ variant = 'default', onTypeClick, onRecordClick, onDoneClick, disabled = false }) => {
  const { handleNoteClick, handleAttachClick, handleTypeClick: defaultHandleTypeClick } = useDock();
  const navigate = useNavigate();
  const { syncAuthFromStorage } = useAuth();

  const handleTypeClick = onTypeClick || defaultHandleTypeClick;
  const handleRecordClick = onRecordClick || handleAttachClick;

  if (variant === 'question') {
    return (
      <DockWrapper>
        <DockContent>
          <DockItem type="button" onClick={handleTypeClick}>
            <DockIcon src="/type-with-bg.svg" alt="Type" />
            <DockLabel>Type</DockLabel>
          </DockItem>
          <DockItem type="button" onClick={handleRecordClick}>
            <DockIcon src="/record-with-bg.svg" alt="Record" />
            <DockLabel>Record</DockLabel>
          </DockItem>
        </DockContent>
      </DockWrapper>
    );
  }

  if (variant === 'done') {
    const handleDefaultDoneClick = async () => {
      // Sync profile from backend to get updated onboarding_completed status
      await syncAuthFromStorage();
      // Navigate to chat - profile should now be updated
      navigate('/chat');
    };

    return (
      <DockWrapper>
        <DockContent style={{ width: '100%' }}>
          <DoneButton onClick={onDoneClick || handleDefaultDoneClick} disabled={disabled}>Done</DoneButton>
        </DockContent>
      </DockWrapper>
    );
  }

  return (
    <DockWrapper>
      <DockContent>
        <DockItem type="button" onClick={handleNoteClick}>
          <DockIcon src="/note.svg" alt="Note" />
          <DockLabel>Note</DockLabel>
        </DockItem>

        <DockItem type="button" onClick={handleAttachClick}>
          <DockIcon src="/attach.svg" alt="Attach" />
          <DockLabel>Attach</DockLabel>
        </DockItem>

        <DockItem type="button" onClick={handleTypeClick}>
          <DockIcon src="/type.svg" alt="Type" />
          <DockLabel>Type</DockLabel>
        </DockItem>
      </DockContent>
    </DockWrapper>
  );
};
